<router-outlet></router-outlet>
<!--<app-toast></app-toast>-->
<!--<p-toast position="bottom-right"></p-toast>-->
<!--<p-confirmDialog appendTo="body"></p-confirmDialog>-->
<div *ngIf="!isCrystalClearAvailable||!isCrystalClearHubServiceAvailable||!isCrystalClearArchiveServiceAvailable"
     [ngClass]="{'overlay': !isCrystalClearAvailable||!isCrystalClearHubServiceAvailable||!isCrystalClearArchiveServiceAvailable}">
  <div class="text-container">
<!--    <i class="pi pi-spin pi-replay item"></i>-->
    <p-progressSpinner class="cc-spinner" strokeWidth="5" animationDuration="1s"></p-progressSpinner>
    <div class="item" *ngIf="!isCrystalClearAvailable">{{'crystal-unavailable' | translate}}</div>
    <div class="item" *ngIf="!isCrystalClearHubServiceAvailable">{{'crystal-hub-unavailable' | translate}}</div>
    <div class="item" *ngIf="isCrystalClearHubServiceAvailable&&!isCrystalClearArchiveServiceAvailable">{{'crystal-archive-unavailable' | translate}}</div>
    <div class="item sub-text" *ngIf="!isCrystalClearHubServiceAvailable||!isCrystalClearArchiveServiceAvailable"
          >{{'interceptor.contact-support' | translate}}
    </div>
    <div class="item sub-text" *ngIf="!isCrystalClearAvailable"
    >{{'crystal-reconnection' | translate}}
      <span class="moving-dot-1">.</span>
      <span class="moving-dot-2">.</span>
      <span class="moving-dot-3">.</span>
    </div>
  </div>
</div>
